import { createContext, FC, useContext } from 'react'
import { SourceData } from 'components/ShareSheet/RecipientSelector/Types'

interface ContextValue {
  sourceData: (includeGroups?: boolean, includeSelf?: boolean) => SourceData
}

export const Context = createContext<ContextValue | undefined>(undefined)

interface Props {
  sourceData: (includeGroups?: boolean, includeSelf?: boolean) => SourceData
}

export const SourceDataProvider: FC<React.PropsWithChildren<Props>> = ({ sourceData, children }) => {
  return <Context.Provider value={{ sourceData }}>{children}</Context.Provider>
}

export const useSourceData = ({
  includeGroups = true,
  includeSelf = false,
}: {
  includeGroups?: boolean
  includeSelf?: boolean
}) => {
  const context = useContext(Context)
  if (context === undefined) {
    throw new Error('useSourceData must be within Provider')
  }

  return context.sourceData(includeGroups, includeSelf)
}
